// removed by extract-text-webpack-plugin
module.exports = {"Wrapper":"_6LFyLmV4gfXkKVLfoZxCm","Meta":"_1Zd-EttHpyUE5GLFYhmr5n","Textarea":"U33QNKbQVD7DgaQXzzuqz"};


//////////////////
// WEBPACK FOOTER
// ./src/components/CommentForm/styles.css
// module id = 668
// module chunks = 0